import { Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Builder from './Builder';

function App() {
  return (
    <>
      <div className='App'>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='builder' element={<Builder />} />
        </Routes>
      </div>
      <div id='modal' />
    </>
  );
}

export default App;
